export default __webpack_public_path__ + "static/media/shizhenyu.71d67315.jpg";